// src/pages/Services.js
import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "../App.css";
import { Link } from "react-router-dom";

import postConstructionImage from "../assets/gallery/postconstructionclean/a1.jpg";
import residentialImage from "../assets/gallery/residentialcleaning/a1.jpg";
import commercialImage from "../assets/gallery/commercialclean/a1.jpg";
import airbnbImage from "../assets/gallery/airbnbcleaning/a1.jpg";
import carpetImage from "../assets/gallery/carpetcleaningandfloorcare/a1.jpg";
import phone_icon from "../assets/img/phone.png";
import { ReactTyped } from "react-typed";

const serviceList = [
  {
    title: "Post Construction Cleaning",
    desc: "Handover ready. Structured. Signed off.",
    points: [
      "Aligned to build schedules and staged handovers",
      "Site induction capability and safety documentation",
      "Documented completion and professional reporting",
      "Commercial and residential project handovers",
    ],
    cta: "You complete the build. We support the presentation.",
    image: postConstructionImage,
    bookText: "Book Post Construction Clean",
  },
  {
    title: "Residential Cleaning",
    desc: "Well maintained. Simply managed.",
    points: [
      "Weekly, fortnightly or one off support",
      "Defined checklists and consistent team allocation",
      "Clear scheduling and transparent invoicing",
      "Family-safe, environmentally responsible products",
    ],
    cta: "Homes stay maintained. Time stays yours.",
    image: residentialImage,
    bookText: "Book Residential Cleaning",
  },
  {
    title: "Commercial Cleaning Auckland",
    desc: "Consistent. Managed. Accountable.",
    points: [
      "Structured service schedules and quality controls",
      "Health and Safety procedures embedded in delivery",
      "Compliance documentation available when required",
      "Systems that reduce follow-up for facility managers",
    ],
    cta: "Clean environments. Fewer follow ups. Clear accountability.",
    image: commercialImage,
    bookText: "Book Commercial Cleaning",
  },
  {
    title: "Airbnb Cleaning",
    desc: "Turnovers managed properly.",
    points: [
      "Turnover scheduling aligned to bookings",
      "Condition reporting to protect your asset",
      "Linen coordination options available",
      "Clear communication with hosts and managers",
    ],
    cta: "Presentation stays consistent. Reviews stay protected.",
    image: airbnbImage,
    bookText: "Book Airbnb Cleaning",
  },
  {
    title: "Carpet Cleaning and Floor Care",
    desc: "Restoration with method. Protection with intent.",
    points: [
      "Recognised methods with commercial-grade equipment",
      "Surface-specific treatment plans",
      "Suitable for residential and commercial environments",
      "Structured reporting for commercial clients",
    ],
    cta: "Surfaces restored with care. Not simply refreshed.",
    image: carpetImage,
    bookText: "Book Carpet and Floor Care",
  },
];

const Services = () => {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <div className="services_fullpage">
      <h2 className="service_main_title" data-aos="fade-down">
        Explore Our Full Services
      </h2>
      {serviceList.map((service, index) => (
        <div className="service_section" key={index} data-aos="fade-up">
          <img
            src={service.image}
            alt={service.title}
            className="service_image"
            data-aos="zoom-in"
          />
          <div
            className="service_content"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            <h3>{service.title}</h3>
            <p className="service_desc">{service.desc}</p>
            <ul className="service_points">
              {service.points.map((point, i) => (
                <li key={i} data-aos="fade-right" data-aos-delay={150 + i * 50}>
                  {point}
                </li>
              ))}
            </ul>
            <p className="service_cta" data-aos="fade-up" data-aos-delay="300">
              {service.cta}
            </p>
            <Link
              to="/booking"
              className="service_btn"
              data-aos="zoom-in"
              data-aos-delay="400"
            >
              {service.bookText} →
            </Link>
          </div>
        </div>
      ))}

      <div className="service_contact_section">
        <div className="about_sub2">
          <div className="about_contact">
            <p className="contact-lead">
              Looking for the cleaning service in Auckland?
              <br />
              Contact us now!
            </p>
            <div className="call_btn" data-aos="fade-down">
              <div className="call_inner">
                <div className="call_icon">
                  <img src={phone_icon} alt="Phone" />
                </div>
                <a className="call-button" href="tel:092430470">
                  09 243 0470
                </a>
              </div>
            </div>
          </div>

          <div className="about_faq">
            <ReactTyped
              strings={["Need help?", "Have questions?", "Check our FAQs!"]}
              typeSpeed={50}
              backSpeed={30}
              loop
            />
            <br />
            <Link className="faq-button" to="/FAQs">
              FAQs
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
